import { useEffect, useRef, useState } from "react";
import { ComboBox, DefaultButton, Dialog, DialogType, IComboBoxOption, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import styles from '../styles/pokemon.module.scss';
import { TSet } from "../constants/types";
import { ObjectArraysEqual } from "../services/Globals";

export interface ISetManagerV2Props {
    Sets : TSet[];
    site: string;
    token: string;
    username: string;
    apiUrl: string;
    setError: Function;
    setMessage: Function;
}

type TTree = {
    Children: TTree[];
    Value: TSet;
    Logo?: File;
} 

const SetManagerV2 : React.FunctionComponent<ISetManagerV2Props> = (props : ISetManagerV2Props) => {
    const [NewSetName, setNewSetName] = useState<string>();
    const [SetsCBOptions, setSetsCBOptions] = useState<IComboBoxOption[]>([]);
    const [NewSetImgFile, setNewSetImgFile] = useState<File>();
    const [NewSetParentSet, setNewSetParentSet ] = useState<string>();
    const [SetTree, setSetTree] = useState<TTree[]>([]);
    const [OrgSetTree, setOrgSetTree] = useState<TTree[]>([]);
    const [showSaveConfirm, setshowSaveConfirm] = useState<boolean>(false);

    const [SelectedSet, setSelectedSet] = useState<TTree>();
    const [SelectedSetNewName, setSelectedSetNewName] = useState<string>();
    const [SelectedSetNewParent, setSelectedSetNewParent] = useState<string>();
    const [SelectedSetNewImg, setSelectedSetNewImg] = useState<File>();

    const logoInputRef = useRef<HTMLInputElement>(null);
    const bannerInputRef = useRef<HTMLInputElement>(null);
    

    useEffect(() => {
        let setCBOptions : IComboBoxOption[] = [];
        
        setCBOptions.push({
            key: "",
            text: ""
        });
        
        props.Sets.forEach(set => {
            setCBOptions.push({
                key: set.name,
                text: set.name
            });
        });
        setSetsCBOptions(setCBOptions);

        let tree : TTree[] = [];
        let orgtree : TTree[] = [];
        props.Sets.forEach(set => {
            if (!set.parentid) {
                tree.push({Children:[], Value: set});
                orgtree.push({Children:[], Value: set});
            }
        });
        tree.forEach(tr => {
            let children : TTree[] = [];
            props.Sets.filter(set => set.parentid === (tr.Value as TSet).id).forEach(sc => {
                children.push({Children:[], Value: sc});
            });
            tr.Children = children ? children : [];
        });
        orgtree.forEach(tr => {
            let children : TTree[] = [];
            props.Sets.filter(set => set.parentid === (tr.Value as TSet).id).forEach(sc => {
                children.push({Children:[], Value: sc});
            });
            tr.Children = children ? children : [];
        });
        setOrgSetTree(orgtree);
        setSetTree(tree);
    },[props.Sets]);

    function addSet() {
        let buf = SetTree;
        if (NewSetParentSet) {
            let tr = buf.filter(b => b.Value.name === NewSetParentSet);
            tr[0].Children.push({Children:[], Value: {
                name: NewSetName, 
                parentid: tr[0].Value.id,
                id: -Date.now(),
                accr: "",
                expansion: "",
                expansionAccr: "",
                size: 0,
                extrasize: 0,
                scardnumber: "",
                scost: "",
                cost: 0,
                imageNames: "",
                cardcount: 0
            }, Logo: NewSetImgFile})
        } else {
            buf.push({Children: [], Value: {
                name: NewSetName,
                id: -Date.now(),
                accr: "",
                expansion: "",
                expansionAccr: "",
                size: 0,
                extrasize: 0,
                parentid: 0,
                scardnumber: "",
                scost: "",
                cost: 0,
                imageNames: "",
                cardcount: 0
            }, Logo: NewSetImgFile});
        }

        let setCBOptions = SetsCBOptions;
        setCBOptions.push({
            key: NewSetName,
            text: NewSetName
        });
        
        setSetsCBOptions(setCBOptions);
        setSetTree(buf);
        setNewSetParentSet("");
        setNewSetImgFile(undefined);
        setNewSetName("");
    }

    function canAddSet() : boolean {
        if (NewSetName?.length > 0) {
            return true;
        }
        return false;
    }

    function canChangeSet() : boolean {
        if (SelectedSetNewName && SelectedSet.Value.name !== SelectedSetNewName) {
            return true;
        }
        if (SelectedSetNewImg) {
            return true;
        }
        if (SelectedSetNewParent || (SelectedSetNewParent === "" && SelectedSet.Value.parentid)) {
            return true;
        }
        return false;
    }

    function SetSelectedSet(t : TTree) {
        setSelectedSetNewName(undefined);
        setSelectedSetNewParent(undefined);
        setSelectedSetNewImg(undefined);
        setSelectedSet(t);
    }

    function updateSet() {
        console.log({SelectedSet});
        let updatedSet : TTree = {
            Children: [],
            Value: {
                id: SelectedSet.Value.id,
                name: SelectedSet.Value.name,
                accr: SelectedSet.Value.accr,
                expansion: SelectedSet.Value.expansion,
                expansionAccr: SelectedSet.Value.expansionAccr,
                size: SelectedSet.Value.size,
                extrasize: SelectedSet.Value.extrasize,
                parentid: SelectedSet.Value.parentid,
                scardnumber: SelectedSet.Value.scardnumber,
                scost: SelectedSet.Value.scost,
                cost: SelectedSet.Value.cost,
                imageNames: SelectedSet.Value.imageNames,
                cardcount: SelectedSet.Value.cardcount
            }
        };

        if (SelectedSetNewName?.length > 0) {
            updatedSet.Value.name = SelectedSetNewName;
        } else {
            updatedSet.Value.name = SelectedSet.Value.name;
        }
        if (SelectedSetNewParent?.length > 0) {
            updatedSet.Value.parentid = SetTree.filter(st => st.Value.name === SelectedSetNewParent)[0].Value.id;
        } else if (SelectedSetNewParent === "") {
            updatedSet.Value.parentid = undefined;
        } else {
            updatedSet.Value.parentid = SelectedSet.Value.parentid;
        }
        if (SelectedSetNewImg) {
            updatedSet.Logo = SelectedSetNewImg;
        } else {
            updatedSet.Logo = SelectedSet.Logo;
        }

        let newSetTree : TTree[] = [];
        if (updatedSet.Value.parentid) {
            SetTree.forEach(s => {
                if (updatedSet.Value.parentid === s.Value.id) {
                    let tempSet : TTree = {Children: [], Value: s.Value, Logo: s.Logo};
                    
                    let updatedChild : boolean = false;
                    s.Children.forEach(c => {
                        if (c.Value.id === updatedSet.Value.id) {
                            updatedChild = true;
                            tempSet.Children.push(updatedSet);
                        } else {
                            tempSet.Children.push(c);
                        }
                    });
                    if (!updatedChild) {
                        tempSet.Children.push(updatedSet);
                    }

                    newSetTree.push(tempSet);
                } else {
                    if (s.Value.id !== updatedSet.Value.id) {
                        let tempSet : TTree = {Children: [], Value: s.Value, Logo: s.Logo};

                        s.Children.forEach(c => {
                            if (c.Value.id !== updatedSet.Value.id) {
                                tempSet.Children.push(c);
                            }
                        });

                        newSetTree.push(tempSet);
                    }
                }
            });
        } else {
            let added : boolean = false;
            SetTree.forEach(s => {
                if (s.Value.id === updatedSet.Value.id) {
                    added = true;
                    newSetTree.push(updatedSet);
                } else {
                    let tempSet : TTree = {Children: [], Value: s.Value, Logo: s.Logo};

                    s.Children.forEach((c)=> {
                        if (c.Value.id === updatedSet.Value.id) {
                            if (c.Value.parentid === updatedSet.Value.parentid) {
                                tempSet.Children.push(updatedSet);
                                added = true;
                            } 
                        }
                    });

                    newSetTree.push(tempSet);
                }
            });
            if (added === false) {
                newSetTree.push(updatedSet);
            }
        }

        newSetTree.sort((a,b) => a.Value.name < b.Value.name ? -1 : 1);

        setSelectedSet(undefined);
        setSetTree(newSetTree);
        setNewSetImgFile(undefined);
        setNewSetName(undefined);
        setNewSetParentSet(undefined);
    }

    function saveInSite() {
        let promises = [];
        SetTree.forEach(st => {
            if (st.Value.id < 0) {
                callBackend(st).then(newID => {
                    if (newID > 0) {
                        st.Children.forEach(c => {
                            c.Value.parentid = newID;
                            promises.push(callBackend(c));
                        });
                    } else {
                        props.setError("Er is iets mis gegaan tijdens de opslag van de sets.");            
                    }
                }).catch(() => {
                    props.setError("Er is iets mis gegaan tijdens de opslag van de sets.");        
                });
            } else {
                promises.push(callBackend(st));
                st.Children.forEach(c => {
                    promises.push(callBackend(c));
                });
            }
        });

        Promise.all(promises).then(() => {
            props.setMessage("De sets zijn successvol opgeslagen.");
        }).catch(() => {
            props.setError("Er is iets mis gegaan tijdens de opslag van de sets.");
        });
    }

    function callBackend(st : TTree) : Promise<number> {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            if (st.Logo) {
                const nameparts = st.Logo.name.split('.');        
                const extention = nameparts[nameparts.length - 1];
                formData.append(st.Value.id + "." + extention, st.Logo);
            }
            formData.append("id", st.Value.id.toString());
            formData.append("name", st.Value.name);
            formData.append("parentid", st.Value.parentid ? st.Value.parentid.toString() : '0');
            formData.append("token",props.token);
            formData.append("username",props.username);
            formData.append("site",props.site);
            fetch(`${props.apiUrl}/UpdateSet`, {
                method: "Put",
                mode: "cors",
                referrerPolicy: "origin-when-cross-origin",
                body: formData
                }).then((response) => response.json()).then((data: number) => {
                    resolve(data);
                }).catch(err => {
                    reject(-1);
            });
        });
    }

    return (
        <Stack horizontal style={{marginLeft:0, display: window.innerWidth > 950 ? "flex":"block"}}>
            <Dialog
                hidden={!showSaveConfirm}
                dialogContentProps={{ type: DialogType.normal }}
                onDismiss={() => { setshowSaveConfirm(false); }}
                modalProps={{ styles: { main: { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }}
            >
                <Stack horizontalAlign='center' style={{backgroundColor:"white",padding:20}}>
                    <Label>Weet u zeker dat u wilt opslaan?</Label>
                    <br/>
                    <table>
                        <tr>
                            <td>
                                <DefaultButton autoFocus style={{margin:5, width:"100%"}} text="Niet opslaan" onClick={() => { setshowSaveConfirm(false); }} />
                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PrimaryButton style={{margin:5, width:"100%"}} text="Tags updaten" onClick={() => { saveInSite(); }} />
                            </td>
                            <td>
                                <Stack horizontal verticalAlign="center">
                                    <Label style={{marginLeft:5}}>Nieuwe sets worden toegevoegd en de setstructuur aangepast.</Label>
                                </Stack>        
                            </td>
                        </tr>
                    </table>
                </Stack>
            </Dialog>
            <Stack style={{margin:10, padding: 10, border: "1px solid blue"}}>
                <h2>Nieuwe Set</h2>
                <hr />
                <TextField label="Naam" value={NewSetName} onChange={(e,v) => { setNewSetName(v); }} />
                <Stack horizontal verticalAlign="end">
                    <ComboBox label="Parent set" options={SetsCBOptions} selectedKey={NewSetParentSet} onChange={(e,o,i,v) => { setNewSetParentSet(v);}} />
                    <PrimaryButton text="Wis" onClick={() => { setNewSetParentSet("");}} />
                </Stack>
                <Stack horizontal style={{marginTop:10}}>
                    <img src={NewSetImgFile ? URL.createObjectURL(NewSetImgFile) : ""} style={{ width: 250, height: 100 }} />
                    <input id="upload" multiple type="file" hidden ref={logoInputRef} onChange={(e) => { setNewSetImgFile(e.target.files[0]); }} />
                    <PrimaryButton text="Set logo" onClick={() => { logoInputRef.current.click(); }} />
                </Stack>
                <hr />
                <Stack horizontalAlign="end" style={{marginTop:10}}>
                    <PrimaryButton disabled={!canAddSet()} text="Toevoegen" onClick={addSet}/>
                </Stack>
            </Stack>
            <Stack style={{margin:10, padding: 10, border: "1px solid blue"}}>
                <Stack horizontal verticalAlign="center">
                    <h2>Sets</h2>
                    <div style={{width:"100%"}}></div>
                    <PrimaryButton disabled={ObjectArraysEqual(OrgSetTree, SetTree)} text="Opslaan in site" style={{width:"stretch"}} onClick={saveInSite} />
                </Stack>
                <hr />
                <ul>
                    {SetTree.map(tr => {
                        return <li key="tr.Value.name">
                                <Stack horizontal verticalAlign="center">
                                    <span style={{cursor:"pointer"}} onClick={() => {SetSelectedSet(tr); }}>{tr.Value.name}</span>
                                </Stack>
                                <ul>
                                    {tr.Children.map(c => {
                                        return <li key="c.Value.name">
                                                  <Stack horizontal verticalAlign="center">
                                                      <span style={{cursor:"pointer"}} onClick={() => {SetSelectedSet(c); }}>{c.Value.name}</span>
                                                  </Stack>
                                               </li>
                                    })}
                                </ul>
                               </li>
                    })}
                </ul>
            </Stack>
            {SelectedSet && <Stack style={{margin:10, padding: 10, border: "1px solid blue"}}>
                <h2>Set aanpassen</h2>
                <hr />
                <TextField label="Naam" defaultValue={SelectedSet.Value.name} value={SelectedSetNewName ? SelectedSetNewName : SelectedSet.Value.name} onChange={(e,v) => { setSelectedSetNewName(v); }} />
                <Stack horizontal verticalAlign="end">
                    <ComboBox label="Parent set" options={SetsCBOptions} selectedKey={SelectedSetNewParent !== undefined ? SelectedSetNewParent : SetTree.filter(st => st.Value.id === SelectedSet.Value.parentid).length ? 
                                                                                      SetTree.filter(st => st.Value.id === SelectedSet.Value.parentid)[0].Value.name : ""} 
                                                                         onChange={(e,o,i,v) => { setSelectedSetNewParent(v);}} />
                    <PrimaryButton text="Wis" onClick={() => { setSelectedSetNewParent("");}} />
                </Stack>
                <Stack horizontal style={{marginTop:10}}>
                    <img src={SelectedSetNewImg ? URL.createObjectURL(SelectedSetNewImg) : 
                              SelectedSet.Logo ? URL.createObjectURL(SelectedSet.Logo) : `https://${props.site}.nl/assets/products/${SelectedSet.Value.id}/${SelectedSet.Value.id}.webp`} style={{ width: 250, height: 100 }} />
                    <PrimaryButton text="Set logo" onClick={() => { bannerInputRef.current.click(); }} />
                </Stack>
                <input id="upload" multiple type="file" hidden ref={bannerInputRef} onChange={(e) => { setSelectedSetNewImg(e.target.files[0]); }} />
                <hr />
                <Stack horizontalAlign="end" style={{marginTop:10}}>
                    <PrimaryButton disabled={!canChangeSet()} text="Opslaan" onClick={updateSet}/>
                </Stack>
            </Stack>}
        </Stack>
    );
}

export default SetManagerV2;